<template>
  <div id="double-sync-modal" class="double-sync-modal">
    <div class="modal-title">Sync Bookings</div>
    <div class="text-info">You can sync from API to fix any booking issues</div>
    <div class="button-wrapper">
      <button class="accept-btn" @click="showSyncAPI">Sync from API</button>
    </div>
    <hr class="line" />
    <div class="footer-wrapper">
      <button class="cancel-btn" @click="hideModal">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoubleSyncModal',
  methods: {
    hideModal() {
      this.$modal.hide('sync-modal')
    },
    showUploadCSV() {
      this.$emit('showUploadCSV')
    },
    showSyncAPI() {
      this.$emit('showSyncAPI')
    }
  }
}
</script>

<style scoped>
.double-sync-modal {
  text-align: left;
  margin: 24px;
  font-size: 14px;
}
.modal-title {
  font-weight: 800;
  font-size: 14px;
  color: #66b015;
}
.text-info {
  margin: 24px 0 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #4a4a4a;
}
.accept-btn {
  background: #66b015;
  border: 1px solid #66b015;
  border-radius: 4px;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  color: #ffffff;
  padding: 12px 48px;
  cursor: pointer;
  width: 100%;
}
.cancel-btn {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #66b015;
  background: #ffffff;
  border: 1px solid #66b015;
  border-radius: 4px;
  padding: 12px 24px;
  cursor: pointer;
}
.button-wrapper {
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}
.line {
  margin: 24px 0;
  border: 0.5px solid #d8dee4;
}
.footer-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>
